import React, { useEffect, useState, useRef, useMemo} from "react";
import { Modal, Collapsible, CollapsibleItem, Icon } from "react-materialize";
// import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { t } from "i18next";
import { withTranslation } from 'react-i18next';

import ReactTableBuilder from "../../../../utils/reactTableBuilder";
import { MuiRow, MuiCol } from "../../../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../../../components/inputs';

function BodyTestQcView(props) {

  let { camera } = props;

  const [currentTest, setCurrentTest] = useState();
  const [logFile, setLogFile] = useState([]);
  const [cellFile, setCellFile] = useState([]);

  const testOptions = useMemo(() => {
    return camera?.qualityControl?.map((test, i) => ({
      label: `${test.status} - ${test.test} - ${test.testedDate}`,
      value: i,
    })) ?? [];
  }, [camera]);

  useEffect(() =>{
    console.log('Effect initial', camera)
    if(camera?.qualityControl?.length > 0){
      console.log('SET ME BABY', camera?.qualityControl?.length - 1)
      setCurrentTest(testOptions[camera?.qualityControl?.length - 1]);
    }
      
  }, [camera])

  useEffect(()=>{
    console.log('USE EFFECT Change loaded test:', currentTest);
    setResultFiles(currentTest?.value);
  },[currentTest])


  function setResultFiles(currentTestId) {
    if(currentTestId >= 0 && camera?.qualityControl?.length > 0){
      console.log('Change loaded test:', currentTestId);
      setLogFile(camera?.qualityControl[currentTestId].results.LogFile);
      setCellFile(camera?.qualityControl[currentTestId].results.LogFile);
    }
  }
  
  return (
    <>
      <MuiRow>
        <MuiCol size={12}>
          <MuiSelect
              id="testresult"
              placeholder={t("testQcView.selectTestResult")}
              options={testOptions}
              value={testOptions.find(opt => opt.value === currentTest?.value) || null}
              onChange={setCurrentTest}
            />

        </MuiCol>
      </MuiRow>
      <MuiRow spacing={2}>
        <MuiCol size={6}>
          <LogTable logLines={logFile} title={"LogFile"}/>
        </MuiCol>
        <MuiCol size={6}>
          <LogTable logLines={cellFile} title={"CellFile"}/>
        </MuiCol>
      </MuiRow>
    </>
  );
}


function LogTable(props) {
  let { logLines, title }=props;
  const columns = [
    {
      Header: t('DateTime'),
      accessor: 'dateTime',
    },
    {
      Header: t('information'),
      accessor: 'info',
    }
  ]
  return <>
    <p style={{fontSize: "20px", textAlign: "center"}}>{title}</p>
    <ReactTableBuilder columns={columns} data={logLines ?? []}/>
  </>;
}


BodyTestQcView.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default compose(withTranslation(),connect(mapStateToProps))(BodyTestQcView);
